import { render, staticRenderFns } from "./stageLimitBalance.vue?vue&type=template&id=fdd72f42&scoped=true&"
import script from "./stageLimitBalance.vue?vue&type=script&lang=js&"
export * from "./stageLimitBalance.vue?vue&type=script&lang=js&"
import style0 from "./stageLimitBalance.vue?vue&type=style&index=0&id=fdd72f42&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd72f42",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
